import { createSelector } from 'reselect'
import { selectCorporateProfile } from 'src/store/selectors/customerProfile'
import { selectFromCurrentCELs } from './dictionary'

export const selectEquityPercent = selectFromCurrentCELs('equityPercent')
const selectReverseMortgageQualified = selectFromCurrentCELs(
  'reverseMortgageQualified'
)

const selectReverseMortgageEnabled = createSelector(
  selectCorporateProfile,
  profile => profile && profile.showReverseMortgage
)

export const selectShowReverseMortgage = createSelector(
  selectReverseMortgageEnabled,
  selectReverseMortgageQualified,
  (enabled, qualified) => enabled && qualified
)
